export const FILTER_PERSISTENCE_ENABLED = false;

export const ROUTE_REQUIRED_FILTERS = {
  '/dossiers': {},
  '/pre-fac': {
    invoicing_status: 'PRÉ-FAC',
  },
  '/supprimes': {
    shipment_is_active: 'false',
  },
  '/facturation-tps': {
    carrier_has_been_paid: 'false',
  },
  '/factures': {},
  '/clients': {},
  '/transporteurs': {},
};

export const CONTEXT_KEYS = ['shipment_stage', 'invoicing_status', 'document_type'];

const STORAGE_KEY = 'routeFiltersCache';

export function getCacheKey(pathname, searchParams) {
  let key = pathname;
  for (const contextKey of CONTEXT_KEYS) {
    const value = searchParams.get(contextKey);
    if (value) {
      key += `|${contextKey}=${value}`;
    }
  }
  return key;
}

export function saveUserFilters(pathname, searchParams) {
  if (!FILTER_PERSISTENCE_ENABLED) return;
  if (!(pathname in ROUTE_REQUIRED_FILTERS)) return;

  const requiredFilters = ROUTE_REQUIRED_FILTERS[pathname] || {};
  const requiredKeys = Object.keys(requiredFilters);
  const systemKeys = ['page', 'page_size'];
  const userFilters = {};

  searchParams.forEach((value, key) => {
    if (!requiredKeys.includes(key) && !systemKeys.includes(key) && !CONTEXT_KEYS.includes(key)) {
      userFilters[key] = value;
    }
  });

  try {
    const cache = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    const cacheKey = getCacheKey(pathname, searchParams);
    cache[cacheKey] = userFilters;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
  } catch (e) {
    console.error('Erreur sauvegarde filtres:', e);
  }
}

export function getSavedUserFilters(pathname, searchParams) {
  if (!FILTER_PERSISTENCE_ENABLED) return {};
  try {
    const cache = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    const cacheKey = getCacheKey(pathname, searchParams);
    return cache[cacheKey] || {};
  } catch (e) {
    console.error('Erreur lecture filtres:', e);
    return {};
  }
}

export function getFiltersForRoute(pathname, searchParams) {
  const requiredFilters = ROUTE_REQUIRED_FILTERS[pathname] || {};
  const savedFilters = getSavedUserFilters(pathname, searchParams);

  return {
    ...savedFilters,
    ...requiredFilters,
  };
}
